// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import header from "./components/header"
import footer from "./components/footer"
import App from './App'
import router from './router'
import http from './action/axios.js'   			//axios实例化后引入取名http
import common from './action/cookie.js'


Vue.config.productionTip = false
Vue.prototype.http = http;       //放入全局
Vue.prototype.common = common;   //存储数据
Vue.prototype.store = store;     //存储数据
Vue.prototype.router = router;   //存储数据

Vue.use(ElementUI)
Vue.component('headerNav', header)
Vue.component('footer1', footer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js